import React from 'react';
import { Form, Input, Select, Radio, Col, Row, Avatar, Divider, InputNumber, DatePicker, message } from 'antd';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
// import { post, config, postFrom } from '../../../../axios';
// import { dicCustomerStatus, dicCustomerSourceType } from '../../../../axios/dictionaries';
import moment from 'moment';

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "详情",
            data: {}
        }
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;

        return <div>
            <ModalDom
                title={title}
                width={900}
                visible={visible}
                loading={loading}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <div className="custom">
                    <Form
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                    >
                        {getFieldDecorator('id', {
                            initialValue: data.id
                        })(
                            <Input type={'hidden'} />
                        )}
                        <Row>
                            <Col span={24}>
                                <CustomRow divider>
                                    <CustomCol label="姓名">
                                        111
                                    </CustomCol>
                                </CustomRow>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </ModalDom>
        </div>
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {} });
    }

    loadPack = (detail) => {
        this.setState({ data: detail })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Remind/components/Detail/index.js